import {Inject, Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {Authentication, AUTHENTICATION} from '@infrastructure/http/authentication/authentication';
import {SignalrHubConnectionFactoryService} from '@vdw/angular-component-library';
import {map, Observable} from 'rxjs';
import {DeletedPlanningItem} from './deleted-planning-item';
import {RealtimePlanning} from './realtime-planning';

@Injectable()
export class SignalrPlanningService implements RealtimePlanning {
  public constructor(
    @Inject(AUTHENTICATION) private readonly authentication: Authentication,
    private readonly backendConfiguration: BackendConfiguration,
    private readonly signalrHubConnectionFactoryService: SignalrHubConnectionFactoryService
  ) {}

  public getPlanningChanges(): Observable<CalendarItemGroup[]> {
    return this.signalrHubConnectionFactoryService
      .getSignalrHubEvents(`${this.backendConfiguration.getPlanningHubEndPoint()}planning`, 'OnPlanningChanged')
      .pipe(
        map((planningChangesJSON: any) =>
          (JSON.parse(planningChangesJSON) as any[]).map((updateForPlanning: any) => CalendarItemGroup.fromJSON(updateForPlanning, this.authentication.getCurrentSubscription()))
        )
      );
  }

  public getDeletedPlanningItem(): Observable<DeletedPlanningItem> {
    return this.signalrHubConnectionFactoryService.getSignalrHubEvents<DeletedPlanningItem>(`${this.backendConfiguration.getPlanningHubEndPoint()}planning`, 'OnPlanningItemDeleted');
  }
}
